"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _5BTJAKB4cjs = require('../__chunks/5BTJAKB4.cjs');



var _XXF5DFSGcjs = require('../__chunks/XXF5DFSG.cjs');
require('../__chunks/5OZ7J4C2.cjs');
require('../__chunks/OTCKJ4OK.cjs');


var _DBVVP6CDcjs = require('../__chunks/DBVVP6CD.cjs');
require('../__chunks/TVPBHOOY.cjs');
require('../__chunks/ZQYY7DF3.cjs');
require('../__chunks/QWIBF3KB.cjs');
require('../__chunks/2XVCJUVB.cjs');
require('../__chunks/NSONUP5C.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/UCZW3OGH.cjs');
require('../__chunks/ITCIC2TC.cjs');
require('../__chunks/MWXEIKZX.cjs');
require('../__chunks/T3QB4FR3.cjs');


var _FH6HQ5JNcjs = require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');





var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');



var _3BSDKDKDcjs = require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/menu/menu-item-radio.tsx
var _misc = require('@ariakit/core/utils/misc');
var _react = require('react');
var _jsxruntime = require('react/jsx-runtime');
var TagName = "div";
function getValue(prevValue, value, checked) {
  if (checked === void 0) return prevValue;
  if (checked) return value;
  return prevValue === value ? false : prevValue;
}
var useMenuItemRadio = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useMenuItemRadio2({
    store,
    name,
    value,
    checked,
    onChange: onChangeProp,
    hideOnClick = false,
    ...props
  }) {
    const context = _XXF5DFSGcjs.useMenuScopedContext.call(void 0, );
    store = store || context;
    _misc.invariant.call(void 0, 
      store,
      process.env.NODE_ENV !== "production" && "MenuItemRadio must be wrapped in a MenuList or Menu component"
    );
    const defaultChecked = _3BSDKDKDcjs.useInitialValue.call(void 0, props.defaultChecked);
    _react.useEffect.call(void 0, () => {
      store == null ? void 0 : store.setValue(name, (prevValue = false) => {
        return getValue(prevValue, value, defaultChecked);
      });
    }, [store, name, value, defaultChecked]);
    _react.useEffect.call(void 0, () => {
      if (checked === void 0) return;
      store == null ? void 0 : store.setValue(name, (prevValue) => {
        return getValue(prevValue, value, checked);
      });
    }, [store, name, value, checked]);
    const isChecked = _FH6HQ5JNcjs.useStoreState.call(void 0, 
      store,
      (state) => state.values[name] === value
    );
    props = _3BSDKDKDcjs.useWrapElement.call(void 0, 
      props,
      (element) => /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _XXF5DFSGcjs.MenuItemCheckedContext.Provider, { value: !!isChecked, children: element }),
      [isChecked]
    );
    props = {
      role: "menuitemradio",
      ...props
    };
    props = _DBVVP6CDcjs.useRadio.call(void 0, {
      name,
      value,
      checked: isChecked,
      onChange(event) {
        onChangeProp == null ? void 0 : onChangeProp(event);
        if (event.defaultPrevented) return;
        const element = event.currentTarget;
        store == null ? void 0 : store.setValue(name, (prevValue) => {
          return getValue(prevValue, value, checked != null ? checked : element.checked);
        });
      },
      ...props
    });
    props = _5BTJAKB4cjs.useMenuItem.call(void 0, { store, hideOnClick, ...props });
    return props;
  }
);
var MenuItemRadio = _PTOCUU2Dcjs.memo.call(void 0, 
  _PTOCUU2Dcjs.forwardRef.call(void 0, function MenuItemRadio2(props) {
    const htmlProps = useMenuItemRadio(props);
    return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
  })
);



exports.MenuItemRadio = MenuItemRadio; exports.useMenuItemRadio = useMenuItemRadio;
